export default __webpack_public_path__ + "static/group-features-ce3b584cf8f4293bc901a7d4f166817d.webm";